import { render } from "./BaseBottomSheet.vue?vue&type=template&id=4547120e"
import script from "./BaseBottomSheet.vue?vue&type=script&lang=js"
export * from "./BaseBottomSheet.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__